import React, {useState} from 'react';
import withStore from "@/hocs/withStore";
import Svg from "@/Pages/All/Svg";
import Menu from "@material-ui/core/Menu";
import {
    OKShareButton,
    PinterestShareButton,
    TelegramShareButton,
    ViberShareButton,
    VKShareButton,
    WhatsappShareButton
} from "react-share";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const ShareAndFavouritesComponent = (props) => {
    const {product = {}, stores = {}, authCheck = false} = props;
    const {favouritesStore = {}} = stores;
    const {id, h1 = '', img = ''} = product;
    const [anchorEl, setAnchorEl] = useState(false);

    const handleClickM = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseM = () => {
        setAnchorEl(false);
    };

    const shareUrl = location.href;

    return <div className={`shareAndFavouritesContainer`}>
        <Svg id={`shareOutlinedIcon`} className={`svg__share`} onClick={(event) => handleClickM(event)} />
        <Menu id={`simple-menu`}
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => handleCloseM()}
        >
            <div className={`dagger-box`} onClick={() => handleCloseM()}>
                <Svg id={`dagger-close`} className={`svg__dagger-close`} />
            </div>
            <div className={`share__head`}>
                <p>Поделиться</p>
            </div>
            <div className={`share__box`}>
                <div className={`share__icon`}>
                    <VKShareButton children={
                        <Svg id={`vk`} className={`svg__vkProduct`} />
                    }
                                   url={shareUrl}
                                   title={h1}
                                   image={img}
                    />
                </div>
                <div className={`share__icon`}>
                    <OKShareButton children={
                        <Svg id={`ok`} className={`svg__okProduct`} />
                    }
                                   url={shareUrl}
                                   title={h1}
                                   image={img}
                    />
                </div>
                <div className={`share__icon`}>
                    <PinterestShareButton children={
                        <Svg id={`pt`} className={`svg__ptProduct`} />
                    }
                                          url={shareUrl}
                                          description={h1}
                                          media={img}
                    />
                </div>
                {/*<div className={`share__icon`}>*/}
                {/*    <ViberShareButton children={*/}
                {/*        <Svg id={`viber`} className={`svg__viberProduct`} />*/}
                {/*    }*/}
                {/*                      url={shareUrl}*/}
                {/*    />*/}
                {/*</div>*/}
                <div className={`share__icon`}>
                    <WhatsappShareButton children={
                        <Svg id={`whatsapp`} className={`svg__whatsappProduct`} />
                    }
                                         url={shareUrl}
                    />
                </div>
                <div className={`share__icon`}>
                    <TelegramShareButton children={
                        <Svg id={`telegram`} className={`svg__telegramProduct`} />
                    }
                                         url={shareUrl}
                    />
                </div>
            </div>
        </Menu>
        <div className={`shareAndFavouritesContainer__favourites`}>
            <FormControlLabel
                control={
                    <Checkbox
                        onClick={(e) => favouritesStore.favouritesChange(e, product)}
                        checked={favouritesStore.favouritesData.some((som) => Number(som.id) === Number(id))}
                        icon={<Svg id={`favouritesHeart`} className={`svg__favouritesHeart`} />}
                        checkedIcon={<Svg id={`favouritesHeartActive`} className={`svg__favouritesHeartActive`} />}
                        name="favoritesHeart" />
                }
            />
        </div>
    </div>
}

export default withStore(ShareAndFavouritesComponent);
